import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center px-4 md:px-8" data-testid="not-found-page">
      <div className="max-w-3xl mx-auto w-full">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-orange-500 mb-4">Error 404</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase">Page not found</h1>
        <p className="text-zinc-400 mt-4">Sorry, we couldn't find that page. It may have moved or been removed.</p>
        <div className="flex flex-wrap gap-4 mt-8 text-orange-500">
          <Link to="/" data-testid="not-found-home-link" className="hover:underline">Go to the homepage</Link>
          <Link to="/browse" data-testid="not-found-browse-link" className="hover:underline">Find creatives</Link>
          <Link to="/jobs" data-testid="not-found-jobs-link" className="hover:underline">Browse jobs</Link>
        </div>
      </div>
    </div>
  );
}
